/**
 * Does an image's format differ from its slot so much that the crop will cut
 * away a large part of it?
 *
 * The slot crops to its ratio regardless (object-cover in the admin preview
 * and in the customer app), so this only decides whether the operator is
 * WARNED — never whether the image is accepted (PO, 2026-10-18).
 *
 * Measured as the ratio of the two formats, so "too tall" and "too wide"
 * count alike. At 0.7 a 16:9 photo (0.78 of 16:7) and a 2:1 one pass; a 3:2
 * camera photo (0.66), 4:3, a square or anything portrait is warned about.
 */
export const RATIO_WARNING_THRESHOLD = 0.7;

const isPositiveSize = (n: number): boolean => Number.isFinite(n) && n > 0;

export const ratioDeviatesStrongly = (
    width: number, height: number, targetRatio: number,
): boolean => {
    // An SVG without intrinsic size reports 0 — nothing to judge.
    if (![width, height, targetRatio].every(isPositiveSize)) return false;
    const actual = width / height;
    const closeness = Math.min(actual, targetRatio) / Math.max(actual, targetRatio);
    return closeness < RATIO_WARNING_THRESHOLD;
};
